<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="custom-popup" style="width: 400px;">
      <div class="popup-header" style="width: 400px;">
        <h3><span class="moderat-meGreen-bold">{{ popupData.full_name }}</span></h3>
      </div>
      <div class="line-312">
        <svg style="width: 100%; height: 1px;">
            <use href="@/assets/svg/newSvgIcon.svg#line312"></use>
        </svg>
      </div>
      <div class="popup-body">
        <p class="moderat-meGreen-bold">Site Name: </p>
        <div class="availability">
          <span>
            {{
              popupData.title
            }}
          </span>
        </div>
      </div>
      <div class="chargers" v-if="showCharger" :v-loading="loading" style="width: 400px;">
        <table class="styled-table w-100">
          <thead>
            <tr>
              <th><span class="moderat-white-bold-12">Usage (MWh)</span></th>
              <th><span class="moderat-white-bold-12">Abatement (tCO2-e)</span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span class="moderat-meGreen-12">{{ popupData.usage_mwh == null ? "" : popupData.usage_mwh.toLocaleString() }}</span></td>
              <td><span class="moderat-meGreen-12">{{ popupData.abatement_tco2 == null ? "" : popupData.abatement_tco2.toLocaleString() }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="popup-footer">
        <!-- <el-button
          @click="handleClick"
          class="view-more"
          link
          style="cursor: pointer"
        >
          {{ showCharger ? "View less" : "View more" }}
        </el-button> -->
      </div>
    </div>
  </template>
  
  <script>

  export default {
    props: {
      popupData: Object,
    },
    data() {
      return {
        loading: false,
        showCharger: true,
      };
    },
    methods: {
      // handleClick() {
      //   this.showCharger = !this.showCharger;
      // },
    },
  };
  </script>
  